var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPizzaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 435.604 435.604",
    style: {
      enableBackground: "new 0 0 435.604 435.604"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M306.325,428.101h-177.04c35.63-13.47,66.31-37.04,88.52-67.23   C240.015,391.061,270.695,414.631,306.325,428.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71A517"
    },
    d: "M259.735,49.591c7.28,7.67,12.48,17.31,14.69,28.06c-4.68,2.83-9.24,5.86-13.66,9.06   c-0.34-0.38-0.69-0.75-1.03-1.12c-0.35-0.37-0.7-0.73-1.06-1.08c-10.46-10.46-24.92-16.93-40.87-16.93   c-16.51,0-31.4,6.91-41.93,18.01c-0.35,0.37-0.7,0.74-1.03,1.12c-4.42-3.2-8.98-6.23-13.66-9.06c2.2-10.75,7.4-20.39,14.69-28.06   c7.74-8.16,17.85-14.07,29.22-16.61c4.09-0.93,8.34-1.41,12.71-1.41s8.62,0.49,12.71,1.41c10.85,2.43,20.56,7.93,28.16,15.52   C259.035,48.861,259.385,49.221,259.735,49.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M260.765,86.711c-16.43,11.91-30.94,26.32-42.96,42.66c-12.02-16.34-26.53-30.75-42.96-42.66   c0.33-0.38,0.68-0.75,1.03-1.12c10.53-11.1,25.42-18.01,41.93-18.01c15.95,0,30.41,6.47,40.87,16.93c0.36,0.35,0.71,0.71,1.06,1.08   C260.075,85.961,260.425,86.331,260.765,86.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD14B"
    },
    d: "M316.845,29.501l-10.52,32.64c-11.16,4.21-21.82,9.42-31.9,15.51   c-2.21-10.75-7.41-20.39-14.69-28.06c-0.35-0.37-0.7-0.73-1.06-1.09c-7.6-7.59-17.31-13.09-28.16-15.52l22.33-24.48l14,13.1   l18-14.1l8,24L316.845,29.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AD14B"
    },
    d: "M182.755,8.501l22.34,24.48c-11.37,2.54-21.48,8.45-29.22,16.61c-7.29,7.67-12.49,17.31-14.69,28.06   c-10.08-6.09-20.74-11.3-31.9-15.51l-10.53-32.64l24,2l8-24l18,14.1L182.755,8.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M274.425,77.651c10.08-6.09,20.74-11.3,31.9-15.51v365.96c-35.63-13.47-66.31-37.04-88.52-67.23   c23.84-32.4,37.93-72.44,37.93-115.75s-14.09-83.34-37.93-115.75c12.02-16.34,26.53-30.75,42.96-42.66   C265.185,83.511,269.745,80.481,274.425,77.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M174.845,86.711c16.43,11.91,30.94,26.32,42.96,42.66c23.84,32.41,37.93,72.44,37.93,115.75   s-14.09,83.35-37.93,115.75c-22.21,30.19-52.89,53.76-88.52,67.23V62.141c11.16,4.21,21.82,9.42,31.9,15.51   C165.865,80.481,170.425,83.511,174.845,86.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M170.285,83.516c-2.979-2.034-6.01-3.997-9.1-5.865c-10.08-6.09-20.74-11.3-31.9-15.51v365.96   c14.576-5.51,28.322-12.713,41-21.366V83.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232.734,252.621c-4.143,0-7.5-3.358-7.5-7.5c0-33.271-9.833-65.306-28.436-92.644   c-2.331-3.425-1.443-8.09,1.98-10.42c3.426-2.331,8.091-1.443,10.42,1.981c20.304,29.836,31.035,64.79,31.035,101.083   C240.234,249.263,236.877,252.621,232.734,252.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.805,341.571c-4.143,0-7.5-3.358-7.5-7.5v-183c0-4.142,3.357-7.5,7.5-7.5s7.5,3.358,7.5,7.5v183   C291.305,338.213,287.947,341.571,283.805,341.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.805,121.571c-4.143,0-7.5-3.358-7.5-7.5v-14c0-4.142,3.357-7.5,7.5-7.5s7.5,3.358,7.5,7.5v14   C291.305,118.214,287.947,121.571,283.805,121.571z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 187.047,
    cy: 127.553,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 228.091,
    cy: 86.905,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 286.248,
    cy: 49.025,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M322.72,24.837c-1.56-1.964-3.989-3.019-6.497-2.811l-18.126,1.51l-6.136-18.408    c-0.771-2.313-2.619-4.107-4.954-4.81c-2.338-0.703-4.867-0.225-6.786,1.278l-12.942,10.138l-9.309-8.71    c-1.464-1.37-3.422-2.098-5.42-2.018c-2.004,0.079-3.894,0.958-5.245,2.439l-19.514,21.39c-3.277-0.5-6.612-0.762-9.989-0.762    c-3.384,0-6.724,0.253-9.999,0.75L188.299,3.445c-1.352-1.482-3.241-2.36-5.245-2.439c-2-0.081-3.956,0.647-5.42,2.018    l-9.309,8.71L155.383,1.596c-1.919-1.503-4.447-1.981-6.786-1.278c-2.335,0.703-4.183,2.497-4.954,4.81l-6.136,18.408    l-18.126-1.51c-2.508-0.208-4.938,0.846-6.497,2.811s-2.033,4.578-1.265,6.965l10.161,31.52v364.783c0,4.142,3.357,7.5,7.5,7.5    h177.042c4.143,0,7.5-3.358,7.5-7.5V63.321l10.162-31.52C324.754,29.414,324.279,26.801,322.72,24.837z M253.268,19.166    l8.454,7.91c2.7,2.527,6.839,2.708,9.749,0.428l9.624-7.539l4.636,13.907c1.095,3.282,4.308,5.389,7.738,5.102l12.786-1.066    l-5.976,18.535c-7.325,2.919-14.442,6.256-21.329,9.975c-3.052-8.13-7.712-15.605-13.754-21.963    c-0.403-0.429-0.806-0.845-1.218-1.256c-5.891-5.885-12.712-10.492-20.121-13.718L253.268,19.166z M211.761,133.818    c23.859,32.425,36.471,70.914,36.471,111.305c0,40.391-12.611,78.879-36.471,111.305c-19.47,26.464-45.244,47.182-74.98,60.45    V73.368C166.517,86.636,192.291,107.354,211.761,133.818z M217.802,117.128c-9.361-11.524-19.881-21.926-31.378-31.063    c8.865-7.12,19.778-10.988,31.378-10.988c11.538,0,22.483,3.873,31.374,10.991C237.681,95.204,227.162,105.605,217.802,117.128z     M217.802,373.118c15.549,19.142,34.298,35.186,55.401,47.486H162.4C183.503,408.304,202.253,392.26,217.802,373.118z     M227.119,360.719c23.64-34.035,36.112-73.876,36.112-115.596c0-41.721-12.473-81.561-36.112-115.596    c19.047-24.413,43.598-43.619,71.703-56.159v343.511C270.717,404.338,246.167,385.132,227.119,360.719z M253.382,53.816    c0.302,0.301,0.593,0.602,0.913,0.943c5.286,5.563,9.199,12.205,11.483,19.43c-1.404,0.901-2.8,1.813-4.181,2.749    c-12.035-10.897-27.461-16.861-43.795-16.861c-16.407,0-31.757,5.961-43.779,16.872c-1.386-0.939-2.789-1.855-4.198-2.76    c2.284-7.225,6.198-13.868,11.489-19.435c9.59-10.111,22.549-15.679,36.488-15.679C231.231,39.074,243.864,44.308,253.382,53.816z     M142.135,38.974c3.437,0.287,6.645-1.821,7.738-5.102l4.636-13.907l9.624,7.539c2.91,2.28,7.051,2.099,9.749-0.428l8.454-7.91    l9.387,10.29c-7.914,3.445-15.137,8.484-21.288,14.969c-6.063,6.38-10.729,13.861-13.782,21.994    c-6.887-3.72-14.004-7.056-21.33-9.976l-5.975-18.535L142.135,38.974z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 273.755,
    cy: 133.749,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 171.138,
    cy: 151.405,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 201.734,
    cy: 207.735,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 202.724,
    cy: 282.808,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 170.94,
    cy: 339.334,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 273.425,
    cy: 356.3,
    r: 7.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaLogo);
export default __webpack_public_path__ + "static/media/pizza-logo.8d2bcca73e2a15929cb999b0cbdce358.svg";
export { ForwardRef as ReactComponent };